import { Model } from '../../infra/model'
import { observable, makeObservable } from 'mobx'
import { QueryInsightPropsDto } from './dtos'

/**
 * A Query Insight for a job.
 */
export class QueryInsight extends Model<QueryInsightPropsDto, QueryInsight> {
  jobId = ''
  periodsOfUnresponsivenessTowardsClient = 0
  countOfTotalFinalReturns = 0
  countOfTotalDraftReturns = 0

  constructor() {
    super()
    makeObservable(this, {
      jobId: observable,
      periodsOfUnresponsivenessTowardsClient: observable,
      countOfTotalFinalReturns: observable,
      countOfTotalDraftReturns: observable,
    })
  }

  parse(attrs: Partial<QueryInsightPropsDto>): Partial<QueryInsight> {
    return {
      jobId: attrs.job_id,
      periodsOfUnresponsivenessTowardsClient:
        attrs.periods_of_unresponsiveness_towards_client,
      countOfTotalFinalReturns: attrs.count_of_total_final_returns,
      countOfTotalDraftReturns: attrs.count_of_total_draft_returns,
    }
  }
}
